import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FormGroup, Input, Label } from "reactstrap";
import { API_URL } from "../../../utils/constants";
import { useAuth } from "../../../context";
import DefaultButton from "../../../components/Buttons/Default";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

function LoginForm() {
  const { t } = useTranslation();
  const { handleLogin } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const login = async () => {
    setIsLoading(true);
    const response = await fetch(API_URL+'/login', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        phone_number: phoneNumber,
        password: password
      }),
    });
    const data = await response.json();      
    if (data.success) {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'user-id',
            userId: data.user.id,
            token: data.token
          })
        );
      }

      handleLogin(data);
      if(data.user.phone_verified_at) {
        navigate("/");
      } else {
        navigate('/otp');
      }
    } else {
      toast.error(data.message || "حدث خطأ أثناء تسجيل الدخول");
    }
    setIsLoading(false);
  }

  return(
    <div>
      <FormGroup>
        <Label>{ t('auth.tabs.login.fields.phone_number.label') }: </Label>
        <Input 
          type="tel"
          inputMode="numeric" 
          value={phoneNumber} 
          onChange={(e) => setPhoneNumber(e.target.value)} 
          placeholder={ t('auth.tabs.login.fields.phone_number.placeholder') } 
        />
      </FormGroup>
      <FormGroup>
        <Label>{ t('auth.tabs.login.fields.password.label') }: </Label>
        <Input 
          type="password" 
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder={ t('auth.tabs.login.fields.password.placeholder') } 
        />
      </FormGroup>
      <FormGroup>
        <Link to={'/password_recovery'} className="text-primary small">{ t('auth.tabs.login.password_reset_link') }</Link>
      </FormGroup>
      <div className="text-center">
        <DefaultButton 
          color="primary" 
          onClick={login}
          loading={isLoading}
          disabled={isLoading || phoneNumber?.length < 8 || password?.length < 8}
        >
          { t('auth.tabs.login.button') }
        </DefaultButton>
      </div>
    </div>
  );
}

export default LoginForm;